import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EmailConfigService } from 'src/app/private/services/emailconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-email-config',
  imports: [SharedModule],
  templateUrl: './create-email-config.component.html',
  styleUrl: './create-email-config.component.scss'
})
export class CreateEmailConfigComponent {
  @Input() type: 'Create' | 'Update' = 'Create';
  @Input() emailConfigDataToEdit: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  @Input() clientId: string = '';
  @Input() centers: any[] = [];

  isLoading = false;
  submitted = false;
  emailCenterForm: FormGroup;

  statusOptions = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' }
  ];

  constructor(
    private fb: FormBuilder,
    private emailConfigService: EmailConfigService,
    private messageService: MessageService
  ) {
    this.emailCenterForm = this.fb.group({
      clientName: ['', Validators.required],
      center_id: ['', Validators.required],
      api_key: ['', Validators.required],
      provider: ['', Validators.required],
      fromEmail: ['', Validators.required],
      reply_to_email: [''],
      host: ['', Validators.required],
      port: [null, Validators.required],
      user: ['', Validators.required],
      password: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.emailConfigDataToEdit) {
      this.emailCenterForm.patchValue(this.emailConfigDataToEdit);
    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

  submitForm() {
    this.submitted = true;
    if (this.emailCenterForm.invalid) {
      this.emailCenterForm.markAllAsTouched();
      return;
    }

    const payload = {
      ...this.emailCenterForm.value,
      client_id: this.clientId,
      status: this.emailCenterForm.value.status
    };

    this.isLoading = true;

    if (this.type === 'Update') {
      payload['id'] = this.emailConfigDataToEdit.id;
      this.emailConfigService.updateEmailConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Center updated successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Update failed!' });
        },
        complete: () => this.isLoading = false
      });
    } else {
      this.emailConfigService.createEmailConfig(payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Center created successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err || 'Create failed!' });
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
